module.exports = __webpack_public_path__ + "static/media/20_profile_picture.c7cbede0.png";